import { AssignmentIndOutlined, EastRounded } from "@mui/icons-material";
import { Suspense } from "react";
import { useNavigate } from "react-router-dom";
import RffDataRow from "../../../../../components/finalForm/shared/RffDataRow";
import LoadingFallback from "../../../../../components/LoadingFallback";
import TitledCard from "../../../../../components/ui/TitledCard";
import Flx from "../../../../../components/layout/Flx";
import { Button } from "@mui/material";

const SummaryTabLoanAssigneesCard = ({ baseUrl }) => {
  const navigate = useNavigate();

  // This function is called when user clicks "Save" in the row

  return (
    <>
      <TitledCard
        title={"Assignee's"}
        icon={<AssignmentIndOutlined className="thin" />}
        variant="h3"
        sx={{
          flexBasis: "480px",
          // flexBasis: "660px",
          //
          flexGrow: 1,
          flexShrink: 0,
        }}
        // headerSx={{ pt: 2 }}
      >
        <Suspense fallback={<LoadingFallback />}>
          <RffDataRow
            topBorder
            placeholder="—"
            name="salesperson"
            label="Salesperson"
            type="selectUserEmail"
          />

          <RffDataRow
            placeholder="—"
            name="processor"
            label="Processor"
            type="selectUserEmail"
          />

          <RffDataRow
            placeholder="—"
            name="underwriter"
            label="Underwriter"
            type="selectUserEmail"
          />

          <RffDataRow
            placeholder="—"
            // name="closer"
            name="loanCloser"
            label="Closer"
            type="selectUserEmail"
          />
          {/* <Flx end fw sx={{ mt: 2 }}>
            <Button
              variant="text"
              onClick={() => navigate(`${baseUrl}/loan-information`)}
              endIcon={<EastRounded className="thin" />}
            >
              Go to Loan Information
            </Button>
          </Flx> */}
        </Suspense>
      </TitledCard>
    </>
  );
};

export default SummaryTabLoanAssigneesCard;
